// extracted by css-extract-rspack-plugin
export default {"Flash":"HiddenUnicode-module__Flash__W7rYG","Button":"HiddenUnicode-module__Button__YXJk7","Octicon":"HiddenUnicode-module__Octicon__zhTmr"};